export default __webpack_public_path__ + "static/pay_with_btc_spanish-fb168bfdf42da279331bcfaa12cacf28.mp4";